/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { useEffect, useRef, useState } from "react"
import { pollingIntervals } from "../constants/pollingIntervals"
import { useAsyncEffect } from "../hooks/useAsyncEffect"
import { IRecord } from "../types/schema"
import { brandColors } from "./EOSThemeProvider"
import { useHistory } from "react-router-dom"

const STORAGE_KEY = "version-token"

export function VersionTokenCheck() {
  const skeem = window.skeem
  const timerRef = useRef<any>(null)
  const [validToken, setValidToken] = useState<boolean>(true)
  const [token, setToken] = useState<IRecord<"versionTokens", "token"> | null>(null)
  const history = useHistory()

  async function getLatestVersion() {
    const [version] = await skeem.fetch2<IRecord<"versionTokens", "token">[]>({
      model: {
        name: "versionTokens",
        attributes: ["token"],
        paginate: { size: 1 },
        sort: { by: "created_at", direction: "DESC" },
      },
    })
    return version
  }

  useEffect(() => {
    if (validToken) {
      return
    } else {
      window.location.href = history.location.pathname
    }
  }, [history.location.pathname])

  useAsyncEffect(async () => {
    const version = await getLatestVersion()
    if (version) {
      localStorage.setItem(STORAGE_KEY, version.token)
    }
  }, [])

  async function pollVersion() {
    const version = await getLatestVersion()
    const currentKey = localStorage.getItem(STORAGE_KEY)
    if (version) {
      setToken(version)
      setValidToken(currentKey === version.token)
    } else {
      setValidToken(true)
    }
  }

  async function updateCurrentVersion() {
    if (token) {
      localStorage.setItem(STORAGE_KEY, token.token)
      location.reload()
    }
  }

  useEffect(() => {
    if (timerRef.current) {
      return
    }
    timerRef.current = setInterval(pollVersion, pollingIntervals.versionCheck)
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
    }
  }, [])

  return validToken ? null : (
    <div
      css={css`
        position: fixed;
        width: 100%;
        background: ${brandColors.mint};
        left: 0;
        bottom: 0;
        z-index: 99999;
        color: ${brandColors.night};
        text-align: center;
        padding: 16px;
      `}
    >
      <span>
        A new version is available: You will be automatically be updated the next time you change
        page.{" "}
        <b
          onClick={updateCurrentVersion}
          css={css`
            cursor: pointer;
          `}
        >
          Update now
        </b>
      </span>
    </div>
  )
}
